import { useContext } from 'react';
import DiscountContext from '~/context/vdp/DiscountContext';
import { useVehiclePricing } from '~/context/vdp/UserVehicleContext';
import useShowTradeIncentivesCopy from '~/hooks/common/selectors/useShowTradeIncentivesCopy';
import useKeyWithInterval from '~/hooks/common/ui/useKeyWithInterval';
import useIsHighNetTrade from '~/hooks/vdp/useIsHighNetTrade';
import { useVehiclePrice } from '~/hooks/vdp/useVehiclePrice';
import formatAndDropDecimal from '~/utilities/formatAndDropDecimal';
import { OriginalPrice, PriceWrapper, StyledPrice } from './Price.styles';

export default function PriceWithDiscount() {
  const { hasDiscount } = useContext(DiscountContext);
  const priceKey = useKeyWithInterval();
  const { finalPrice, originalPrice } = useVehiclePrice();
  const { price: { tradeIncentive = 0 } = {} } = useVehiclePricing();
  const isHighNetTrade = useIsHighNetTrade();
  const { showTradeIncentive } = useShowTradeIncentivesCopy({ tradeIncentive });
  const shouldShowIncentive = showTradeIncentive && !isHighNetTrade;
  const showOriginalPrice = hasDiscount || shouldShowIncentive;

  return finalPrice ? (
    <PriceWrapper>
      <StyledPrice key={priceKey}>
        ${formatAndDropDecimal(finalPrice)}
      </StyledPrice>
      {showOriginalPrice && (
        <OriginalPrice>
          was{' '}
          <span className="line-through">
            ${formatAndDropDecimal(originalPrice)}
          </span>
        </OriginalPrice>
      )}
    </PriceWrapper>
  ) : null;
}
